export default {
  title: '商品分类',
  addPrimary: '新增一级分类',
  addSecondary: '新增二级分类',
  collapseAll: '收起所有分类',
  language: '语言',
  categoryName: '分类名称',
  categoryNamePlaceholder: '请输入分类名称',
  searchPlaceholder: '请输入关键词搜索',
  giftCount: '礼品数量',
  modify: '修改',
  multilingual: '多语言',
  addPrimaryTitle: '添加一级分类',
  addSecondaryTitle: '添加二级分类',
  editTitle: '修改分类',
  multiLangTitle: '多语言',
  deleteIrreversible: '删除后不可恢复，确定要删除吗？',
  langRequired: '请选择语言',
  nameRequired: '请输入分类名称',
  firstAddTip: '首次添加默认系统语言，如果是点击【多语言】则默认列表查询条件所选的语言',
};
